/* LAYOUT */
export const SET_SIDEBAR = "@LAYOUT/SET_SIDEBAR";
export const SET_LATEST_APP_VERSION = "@LAYOUT/SET_LATEST_APP_VERSION";
export const SET_ALL_APP_VERSIONS = "@LAYOUT/SET_ALL_APP_VERSIONS";
export const SET_APP_ANNOUNCEMENTS = "@LAYOUT/SET_APP_ANNOUNCEMENT";
